import React, { useEffect, useState } from "react";
import './signup.css';
import { connect } from "react-redux";
import {getSignUpPageData, updateSignupUniqueCode} from "../../actions/signupAction";
import Loading from "../common/Loading";
import SignUpForm from "./SignUpForm";
import SelectPackage from "./SelectPackage";
import SignUpSuccess from "./SignUpSuccess";
import {Helmet} from "react-helmet";
import Utils from "../../helpers/Utils";
import {CODE_SNIPPET} from "../../constants/CoreConstants";
import OtpForm from "./OtpForm";
import SignUpFormInsurance from "./SignUpFormInsurance";
import useQueryParam from "../../hooks/useQueryParam";
import {useHistory} from "react-router-dom";
import {getCookie} from "../../helpers/Cookie";
import Packages from "./packages/Packages";

const checkAddressUrl = () => {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('redirect_url');
}

const validTypes = ['paid', 'trial'];

const SignUp = (props) => {
    const history = useHistory();

    const [loading, setLoading] = useState(props.loading);
    const [validationCheck, setValidationCheck] = useState(props.validationCheck);
    const [isSignUpSuccess, setIsSignUpSuccess] = useState(props.isSignUpSuccess);
    const [pageInfo, setPageInfo] = useState({
        logo: '',
        favIcon: '',
        agencyName: '',
        privacyPolicy: '',
        agencyThemeColor: '',
        agencyTextColor: '',
        termsAndConditions: '',
        agencyId: null
    });
    const uniqueCode = useQueryParam('unique_code');
    const insuranceCompanyAgencyIds = [236, 238];

    useEffect(() => {
        const channel = new BroadcastChannel('pypepro-channel');

        // Listen for incoming messages from other tabs
        channel.addEventListener('message', (event) => {
            //   setMessage(event.data);
            if (event.data && event.data.action && event.data.action && event.data.link === "RELOAD") {
                window.location.reload();
            }
        });

        // Clean up the channel when component unmounts
        return () => {
            channel.close();
        };
    }, []);

    useEffect(() => {

        try {
            if (!validTypes.includes(props.match.params.type)){
                history.push('/user/login');
            }
        }catch (e){
            history.push('/user/login');
        }

        //Check access token
        const accessToken = getCookie(process.env.REACT_APP_ACCESS_TOKEN);
        if (accessToken.length !== 0) {
            let redirect_url = checkAddressUrl()
            if (redirect_url !== undefined && redirect_url !== null) {
                history.push(redirect_url);
            } else {
                history.push('/');
            }
        }

        document.body.style.backgroundColor = "white";
        let payload = {
            'type': props.match.params.type
        };

        if (uniqueCode){
            props.updateSignupUniqueCode(uniqueCode);
            payload.uniqueCode = uniqueCode;
        }

        props.getSignUpPageData(payload, responseSignUpPageData);
    }, []);

    useEffect(() => {
        setValidationCheck(props.validationCheck);
    }, [props.validationCheck]);

    useEffect(() => {
        setLoading(props.loading);
    }, [props.loading]);

    useEffect(() => {
        setIsSignUpSuccess(props.isSignUpSuccess);
    }, [props.isSignUpSuccess]);

    const responseSignUpPageData = response => {
        setPageInfo({
            ...pageInfo,
            logo: response.data.agencyLogo,
            favIcon: response.data.favIcon,
            agencyName: response.data.agencyName,
            agencyId: response.data.agencyId,
            agencyAccentColor: response.data.agencyAccentColor,
            agencyThemeColor: response.data.agencyThemeColor,
            agencyTextColor: response.data.agencyTextColor,
            privacyPolicy: response.data.privacyPolicy,
            termsAndConditions: response.data.termsAndConditions,
            isStripeBilling: response.data.stripe_billing ? response.data.stripe_billing : null
        });
        Utils.loadCodeSnippets(CODE_SNIPPET.REGISTRATION, {agencyId: response.data.agencyId});
    }

    return (
        <div className="signup__wrapper signup__wrapper__wr_v2 height-100" style={{ background:  pageInfo.agencyThemeColor}}>
            <Helmet>
                <link rel="icon" href={pageInfo.favIcon} />
                <title>{`Signup | ${pageInfo.agencyName}`}</title>
                <meta name="description" content="All-In-One Sales & Marketing Platform" />
                <meta name="keywords" content={`CRM, Automation, Sales, Marketing, ${pageInfo.agencyName}`} />
                <meta name="author" content={pageInfo.agencyName} />
                {pageInfo?.agencyId == 82 &&
                <script async src="https://cdn.tolt.io/tolt.js" data-tolt="b48a2a3f-cc72-41d0-af5e-2211ae0108dc"></script>
                }
            </Helmet>
            {(loading || props.autoSubmitting) &&
                <div className='pre-loader'>
                    <Loading />
                </div>
            }
            {
                (!loading && !props.autoSubmitting) && (
                    !isSignUpSuccess ?
                        <React.Fragment>
                            {(!validationCheck && (insuranceCompanyAgencyIds.includes(pageInfo?.agencyId))) ? (
                                <SignUpFormInsurance
                                    signupType={props.match.params.type}
                                    pageLogo={pageInfo.logo}
                                    accentColor={pageInfo.agencyAccentColor}
                                    agencyThemeColor={pageInfo.agencyThemeColor}
                                    agencyTextColor={pageInfo.agencyTextColor}
                                    agencyName={pageInfo.agencyName}
                                    privacyPolicy={pageInfo.privacyPolicy}
                                    termsAndConditions={pageInfo.termsAndConditions}
                                    setIsSignUpSuccess={setIsSignUpSuccess}
                                />
                            ) : !validationCheck ? (
                                <SignUpForm
                                    signupType={props.match.params.type}
                                    pageLogo={pageInfo.logo}
                                    accentColor={pageInfo.agencyAccentColor}
                                    agencyThemeColor={pageInfo.agencyThemeColor}
                                    agencyTextColor={pageInfo.agencyTextColor}
                                    agencyName={pageInfo.agencyName}
                                    privacyPolicy={pageInfo.privacyPolicy}
                                    termsAndConditions={pageInfo.termsAndConditions}
                                />
                            ) : null}
                            {
                                validationCheck &&
                                (
                                    insuranceCompanyAgencyIds.includes(pageInfo?.agencyId) ?
                                        <Packages/> :
                                        <SelectPackage
                                            agencyThemeColor={pageInfo.agencyThemeColor}
                                            agencyTextColor={pageInfo.agencyTextColor}
                                            privacyPolicy={pageInfo.privacyPolicy}
                                            termsAndConditions={pageInfo.termsAndConditions}
                                            agencyId={pageInfo?.agencyId}
                                            type={props.match.params.type}
                                            isStripeBilling={pageInfo.isStripeBilling}
                                        />
                                )
                            }
                        </React.Fragment> :
                        (   props.otpNeededForUser !== '' ?
                                <OtpForm
                                    signupType={props.match.params.type}
                                    pageLogo={pageInfo.logo}
                                    accentColor={pageInfo.agencyAccentColor}
                                    agencyName={pageInfo.agencyName}
                                    privacyPolicy={pageInfo.privacyPolicy}
                                    termsAndConditions={pageInfo.termsAndConditions}
                                    otpNeededForUser={props.otpNeededForUser}
                                /> :
                            <SignUpSuccess logo={pageInfo.logo}  agencyName={pageInfo.agencyName}/>
                        )
                )
            }
        </div>
    );
};


const mapStateToProps = state => {
    return {
        validationCheck: state.signupReducer.validationCheck,
        loading: state.signupReducer.loading,
        agencyId: state.signupReducer.agencyId,
        isSignUpSuccess: state.signupReducer.isSignUpSuccess,
        userEmail: state.signupReducer.email,
        otpNeededForUser: state.signupReducer.otpNeededForUser,
        autoSubmitting: state.signupReducer.autoSubmitting
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getSignUpPageData: (params, callback) => dispatch(getSignUpPageData(params, callback)),
        updateSignupUniqueCode: (payload) => dispatch(updateSignupUniqueCode(payload))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);